/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoMicrosoftIcon20Regular = forwardRef('LogoMicrosoftIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 4.5A2.25 2.25 0 0 1 4.5 2.25h11a2.25 2.25 0 0 1 2.25 2.25v11a2.25 2.25 0 0 1-2.25 2.25h-11a2.25 2.25 0 0 1-2.25-2.25v-11Zm1.5 6.25v4.75c0 .414.336.75.75.75h4.75v-5.5h-5.5Zm5.5-1.5h-5.5V4.5a.75.75 0 0 1 .75-.75h4.75v5.5Zm1.5 1.5v5.5h4.75a.75.75 0 0 0 .75-.75v-4.75h-5.5Zm5.5-1.5h-5.5v-5.5h4.75a.75.75 0 0 1 .75.75v4.75Z" })));
});
